import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react";
import { Dialog, DialogFooter, DialogType } from "office-ui-fabric-react/lib-commonjs";
import ReactDOM from "react-dom";
import { clearRulersOnScreen } from "../../../actions/drawingtoolbar-actions";
import { languageIds } from "../../../lib/localization/languageIds";

const root = document.getElementById("root");

class Contact extends PureComponent{
  state = {
    showAgreement: false
  };

  constructor( props ) {
    super(props);
    this.container = document.createElement("div");
  }

  componentDidMount() {
    root.appendChild(this.container);
  }

  componentWillUnmount() {
    root.removeChild(this.container);
  }

  render() {
    const {
      lang,
      content
    } = this.props;

    const onShowAgreement = () => {
      this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
      this.setState({ showAgreement: true });
    };

    const onHideAgreement = () => {
      this.setState({ showAgreement: false });
    };

    const renderAgreement = () => {
      const { showAgreement } = this.state;

      const minWidth = parseInt(window.innerWidth * .7, 10);

      return ReactDOM.createPortal(
        ( <Dialog
          hidden={!showAgreement}
          onDismiss={() => this.handleDialogClose}
          minWidth={minWidth}
          maxWidth={minWidth}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].agreementTitle
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <div>
            {content[lang].agreenmentText.split("\n").map(( s, i ) => ( <p key={i}>{s}</p> ))}
          </div>
          <DialogFooter>
            <PrimaryButton onClick={onHideAgreement} text={content[lang].agreedToTerms} />
          </DialogFooter>
        </Dialog> ),
        this.container
      );
    };

    const getPrivacyPolicyUrl = () => {
      let url = "";
      switch (this.props.language.id) {
        case languageIds.frCA:
          url = "https://cultec.com/privacy-policy";
          break;
        case languageIds.enGB:
          url = "https://cultec.com/privacy-policy";
          break;
        case languageIds.frFR:
          url = "https://cultec.com/privacy-policy";
          break;
        case languageIds.deDE:
          url = "https://cultec.com/privacy-policy";
          break;
        default:
           url = "https://cultec.com/privacy-policy"// +
          //   "?sp=r&st=2020-02-19T13:03:26Z&se=2050-02-19T21:03:26Z&spr=" +
          //   "https&sv=2019-02-02&sr=b&sig=1lxycxsmCrcN4V67187tGJbSLPeIEwWdrXFs34aX1dg%3D";
          break;
      }
      return url;
    };

    return (
      <div style={{ padding: '10px', lineHeight: '1.2rem' }}>
        <strong>{content[lang].cultecTechnicalServices}</strong>
        <div>
          {content[lang].phone} <a href="tel:+1-203-775-4416">(203) 775-4416</a>
        </div>
        <div>
          {content[lang].tollFree} <a href="tel:+1-800-4-CULTEC">1(800)-4-CULTEC</a>
        </div>
        <div>
          {content[lang].email} <a href="mailto:stormgenie@Cultec.com">StormGenie@Cultec.com</a>
        </div>
        <div>
          <a href="https://cultec.com/rep-finder/">Find a Rep</a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href={getPrivacyPolicyUrl()}>
            {content[lang].privacyPolicy}
          </a>
        </div>
        <div>
          {content[lang].version} {process.env.REACT_APP_MINICAD_VERSION}
        </div>
        <div style={{ paddingTop: '5px' }}>
          <DefaultButton onClick={onShowAgreement} text={content[lang].termsOfService} />
        </div>
        {renderAgreement()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lang: state.localization.lang,
    language: state.localization.language,
    content: state.localization.content
  };
};

const mapDispatchToProps = {
  clearRulersOnScreen
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(Contact);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/Contact/index.js